<template>
  <div class="export_main">
    <!-- <template v-if="showBtn">
      <el-button @click="makeExport" type="primary">预约导出</el-button>
      <el-button @click="seeExport" type="primary">查看导出</el-button>
    </template> -->
    <template>
      <el-button @click="makeExport" type="primary">预约导出</el-button>
      <el-button @click="seeExport" type="primary">查看导出</el-button>
    </template>
    <!-- 查看导出列表弹框 -->
    <div v-if="isSeeExport">
      <el-dialog
        v-dialogDrag
        class="export-dialog"
        title="查看导出表"
        :close-on-click-modal="false"
        :visible.sync="isSeeExport"
        width="80%"
      >
        <el-table :data="scribeList" height="500" style="width: 100%">
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-form label-position="left" class="demo-table-expand">
                <el-form-item v-for="(prop, index) in props.row.propList" :key="index" :label="prop.name">
                  <span>{{ prop.value }}</span>
                </el-form-item>
                <el-form-item v-if="!props.row.propList.length">
                  <span>无搜索条件</span>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column label="序号" type="index" width="60"></el-table-column>
          <el-table-column label="文件名" prop="file_name"></el-table-column>
          <el-table-column label="预约时间" prop="modifyTime"></el-table-column>
          <el-table-column label="状态" prop="status">
            <template slot-scope="scope">
              {{ scope.row.export_status }}
            </template>
          </el-table-column>
          <el-table-column label="操作" prop="desc">
            <template slot-scope="scope">
              <el-button
                type="text"
                :disabled="scope.row.file_url ? false : true"
                @click="downloadfile(scope.row.file_url, scope.row)"
              >
                {{ scope.row.downloadTitle }}
              </el-button>
              <!-- <a :class="scope.row.file_url ? 'color409EFF' : 'disabled'" :disabled="scope.row.file_url" :href="scope.row.file_url" :download="downloadName">下载</a> -->
            </template>
          </el-table-column>
        </el-table>
        <div class="page-box">
          <!-- 分页 totalNum 总数  pageChange 分页  handleSizeChange 一页显示多少个 返回page 页码 limit 每页个数-->
          <pagination
            v-if="popTotalNum > 0"
            :total="popTotalNum"
            :page="popPageIndex"
            @pageChange="popPageChange"
            @handleSizeChange="popPageChange"
            v-bind:limit.sync="popPageSize"
          ></pagination>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { dateFormatFn, dateFormat } from './common'
import pagination from '../components/Pagination'
export default {
  name: 'ExportExcel',
  components: { pagination },
  data() {
    return {
      isSeeExport: false,
      popTotalNum: 0, // 查看导出表总条数
      popPageSize: 50, // 查看导出表显示个数
      popPageIndex: 1, // 查看导出表页码
      scribeList: [], // 查看导出列表
      export_status: [
        // 导出状态
        { value: 1, label: '导出中' },
        { value: 2, label: '导出完成' },
        { value: 3, label: '已失效' },
        { value: 4, label: '导出失败' }
      ]
    }
  },
  props: {
    showBtn: {
      type: Boolean,
      default: true
    },
    // 参数
    searchInfo: {
      type: Object,
      required: true
    },
    // 所有筛选条件参数
    dataArr: {
      type: Array,
      required: true
    },
    // 预约导出系统名称
    system_name: {
      type: String,
      required: true
    },
    // 导出表名称
    module_name: {
      type: String,
      required: true
    },
    // 查看是否正在导出接口
    is_leading_out: {
      type: Function,
      required: true
    },
    // 开始导出接口
    start_export: {
      type: Function,
      required: true
    },
    // 查看导出列表接口
    look_export: {
      type: Function,
      required: true
    },
    // 查看是否正在导出接口url
    is_leading_out_url: {
      type: String,
      required: true
    },
    // 开始导出接口url
    start_export_url: {
      type: String,
      required: true
    },
    // 查看导出列表接口url
    look_export_url: {
      type: String,
      required: true
    },
    // 导出表名称
    export_name: {
      type: String
    }
  },
  methods: {
    dTime(t) {
      var strT = t.toString()
      return strT[1] ? strT : '0' + strT
    },
    //预约导出
    makeExport() {
      //查询是否能导出 true 能导出 false 不能导出
      let updata = Object.assign({ system_name: this.system_name }, this.searchInfo)
      this.is_leading_out(
        {
          // 是否正在导出接口
          data: {
            module_name: this.module_name,
            system_name: this.system_name
          },
          success: res => {
            if (res.code) {
              if (res.data) {
                this.$alert(
                  '<p>后台正在进行导出操作，预估需要<span style="font-weight: 600; font-size: 16px;">3~5分钟</span>；</p><p>您可以通过“查看导出”按钮查看导出数据；</p><p>已完成的表格将为您保留30天。</p>',
                  '预约导出',
                  {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '确定',
                    callback: action => {
                      this.start_export(
                        {
                          // 开始导出
                          data: updata,
                          success: res => {
                            if (res.data) {
                            } else {
                              this.$message.error('导出错误')
                            }
                          }
                        },
                        this.start_export_url
                      )
                    }
                  }
                )
              } else {
                this.$alert('您有一个正在导出的表格,请在导出完成后再次预约导出。', '预约导出', {
                  confirmButtonText: '确定',
                  callback: action => {}
                })
              }
            }
          }
        },
        this.is_leading_out_url
      )
    },
    //查看导出
    seeExport() {
      // this.isSeeExport = true;
      this.popPageIndex = 1 //查看导出表页码
      this.popPageSize = 50 //查看导出表显示个数
      this.subscribe_list()
    },
    //查看导出接口
    subscribe_list() {
      let updata = Object.assign({ module_name: this.module_name, system_name: this.system_name }, this.searchInfo)
      this.look_export(
        {
          // 查看导出列表接口
          pageIndex: this.popPageIndex,
          pageSize: this.popPageSize,
          data: updata,
          success: res => {
            if (!res) return
            this.isSeeExport = true
            let content = res.data.content
            // 处理请求参数
            if (content.length) {
              let dataArr = this.dataArr
              dataArr.map((item, index) => (item.sort = index + 1))
              content.forEach(item => {
                item.propList = []
                let object = item.obj
                if (this.system_name === 'FMS') {
                  // FMS展示搜索条件处理
                  if (object.order_status_array) {
                    let index = object.order_status_array.indexOf(3)
                    if (index >= 0) {
                      object.order_status_array.splice(index, 1)
                    }
                  }
                }
                for (const key in object) {
                  if (object.hasOwnProperty(key)) {
                    let curent = dataArr.find(item => item.id === key)
                    if (curent) {
                      let val = ''
                      let sort = curent.sort
                      switch (curent.type) {
                        case 'remoteSearch': // 远程搜索
                        case 'input': // 文本
                          val = object[curent.id]
                          break
                        case 'select': // 普通下拉
                          val = curent.value.find(item => item.value == object[curent.id]).label
                          break
                        case 'allSelect': // 多选下拉
                          let selectValList = object[curent.id]
                          if (typeof selectValList === 'string') {
                            selectValList = selectValList.split(',')
                          }
                          let valList = []
                          for (let i = 0, item; i < selectValList.length; i++) {
                            item = selectValList[i]
                            let allSelectList = curent.value
                            let obj = allSelectList.find(cur => cur.value == item || `${cur.value}`.indexOf(item) >= 0)
                            if (obj) {
                              valList.push(obj.label)
                            }
                          }
                          val = valList.join(',')
                          break
                        case 'data': // 时间 ex: 2019-09-10
                          val = `${dateFormatFn(object[curent.id], 'noHms')}`
                          break
                        case 'time_scope': // 时间 ex: 2019-09-10 至 2019-09-11
                          val = `${dateFormatFn(object[curent.id], 'noHms')} 至 ${dateFormatFn(
                            object[curent.id2],
                            'noHms'
                          )}`
                          break
                        case 'time_scope2': // 时间 ex: 2019-09-10 12:12:12 至 2019-09-11 12:12:12
                          val = `${dateFormatFn(object[curent.id])} 至 ${dateFormatFn(object[curent.id2])}`
                          break
                        case 'time_scope3': // 时间 ex: 2019-09-10 12:12 至 2019-09-11 12:12
                          val = `${dateFormatFn(object[curent.id])} 至 ${dateFormatFn(object[curent.id2])}`
                          break
                        case 'price': // 价格间隔 ex: 10 - 100
                          val = `${object[curent.id]} - ${object[curent.id2]}`
                          break
                        case 'rangeNumber': // 积分余额, 兑换次数区间
                          val = `${object[curent.id]} - ${object[curent.id2]}`
                          break
                        case 'num': // num类型 ex: 已报人数
                          val = `${object[curent.id]}`
                          break
                        default:
                          // 默认为 -- 输出类型
                          console.log(`type:${curent.type}`)
                          val = '--'
                          break
                      }
                      item.propList.push({
                        name: curent.label,
                        value: val,
                        sort
                      })
                    }
                  }
                }
                item.propList.sort((a, b) => a.sort - b.sort)
              })
              this.scribeList = content
              this.scribeList.map(item => {
                item.file_name = this.export_name || item.file_name
                item.downloadTitle = '下载'
                item.export_status = this.export_status.find(ex => ex.value == item.status).label || '--' // 状态
                item.modifyTime = dateFormat(item.modifyTime || item.modify_time)
              })
            }
            this.popTotalNum = Number(res.data.totalElements)
          },
          error: err => {
            this.$message.error(err)
          }
        },
        this.look_export_url
      )
    },
    //查看导出表分页
    popPageChange(size) {
      console.log(size)
      this.popPageIndex = size.page
      this.popPageSize = size.limit
      this.subscribe_list()
    },
    //下载文件
    downloadfile(url, row) {
      var myDate = new Date()
      var y = myDate.getFullYear()
      var month = this.dTime(myDate.getMonth() + 1)
      var d = this.dTime(myDate.getDate())
      var h = this.dTime(myDate.getHours())
      var minutes = this.dTime(myDate.getMinutes())
      this.downloadName = (this.export_name || this.module_name) + y + month + d + '_' + h + minutes
      this.downloadRes(url, this.downloadName, row)
    },
    // 下载文件
    async downloadRes(url, name, row) {
      let response = await fetch(url)
      //禁止点击按钮
      row.file_url = null
      row.downloadTitle = '下载中'
      // 内容转变成blob地址
      let blob = await response.blob()
      console.log(blob, 'blob')
      // 创建隐藏的可下载链接
      let objectUrl = window.URL.createObjectURL(blob)
      console.log(objectUrl, 'objectUrl')
      let a = document.createElement('a')
      //地址
      a.href = objectUrl
      //修改文件名
      a.download = name
      // 触发点击
      document.body.appendChild(a)
      a.click()
      //移除
      setTimeout(() => document.body.removeChild(a), 1000)
      row.file_url = url
      row.downloadTitle = '下载'
    }
  }
}
</script>
<style scoped>
.export_main {
  padding: 0;
}
.export_main .el-button {
}
.export-dialog .el-form-item {
  margin: 0;
}
.btn-com-dashed {
  user-select: none;
  cursor: pointer;
  font-size: 14px;
  color: #333333;
  box-sizing: border-box;
  display: inline-block;
  border: 1px solid #dcdfe6;
  padding: 0 14px;
  border-radius: 4px;
  height: 32px;
  line-height: 32px;
  /* padding-left: 32px;  */
}
.btn-com-dashed:hover {
  border: 1px solid #8ed6ff;
  background: #f4fbff;
  color: #1890ff;
}
.btn-com-dashed:active {
  border: 1px solid #0098ef;
  color: #0098ef;
}
/* .yuyue_icon::before{
  display: inline-block;
  width: 14px;
  height: 14px;
  background: url('../img/icon_chakan.svg') no-repeat;
  background-size: 14px;
  vertical-align: middle;
}
.yuyue_icon::before:hover{
  background: url('../img/icon_chakan_hover.svg') no-repeat;
}
.yuyue_icon::before:active{
  background: url('../img/icon_chakan_active.svg') no-repeat;
} */

/* .chakan_icon {
  background: url('../img/icon_chakan.svg') no-repeat;
  background-position: 14px 9px;
}
.chakan_icon:hover {
  background: url('../img/icon_chakan_hover.svg') no-repeat;
  background-position: 14px 9px;
}
.chakan_icon:active {
  background: url('../img/icon_chakan_active.svg') no-repeat;
  background-position: 14px 9px;
}

.yuyue_icon {
  background: url('../img/icon_yuyue.svg') no-repeat;
  background-position: 14px 9px;
}
.yuyue_icon:hover {
  background: url('../img/icon_yuyue_hover.svg') no-repeat;
  background-position: 14px 9px;
}
.yuyue_icon:active {
  background: url('../img/icon_yuyue_active.svg') no-repeat;
  background-position: 14px 9px;
} */
</style>
